var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector222Down(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 3C23.3417 3 23.6994 3.11853 23.9631 3.3295C24.2268 3.54048 24.375 3.82663 24.375 4.125V15.375C24.375 15.6734 24.2268 15.9595 23.9631 16.1705C23.6994 16.3815 23.3417 16.5 22.9688 16.5C22.5958 16.5 22.2381 16.3815 21.9744 16.1705C21.7107 15.9595 21.5625 15.6734 21.5625 15.375V4.125C21.5625 3.82663 21.7107 3.54048 21.9744 3.3295C22.2381 3.11853 22.5958 3 22.9688 3ZM7.96875 3C8.34171 3 8.6994 3.11853 8.96312 3.3295C9.22684 3.54048 9.375 3.82663 9.375 4.125L9.375 13.875C9.375 14.1734 9.22684 14.4595 8.96312 14.6705C8.6994 14.8815 8.34171 15 7.96875 15C7.59579 15 7.2381 14.8815 6.97438 14.6705C6.71066 14.4595 6.5625 14.1734 6.5625 13.875V4.125C6.5625 3.82663 6.71066 3.54048 6.97438 3.3295C7.2381 3.11853 7.59579 3 7.96875 3ZM16.875 4.125C16.875 3.82663 16.7268 3.54048 16.4631 3.3295C16.1994 3.11853 15.8417 3 15.4688 3C15.0958 3 14.7381 3.11853 14.4744 3.3295C14.2107 3.54048 14.0625 3.82663 14.0625 4.125L14.0625 19.875C14.0625 20.1734 14.2107 20.4595 14.4744 20.6705C14.7381 20.8815 15.0958 21 15.4688 21C15.8417 21 16.1994 20.8815 16.4631 20.6705C16.7268 20.4595 16.875 20.1734 16.875 19.875V4.125Z",
    fill: "#A7A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector222Down);
export default __webpack_public_path__ + "static/media/Vector222Down.32973778df9f4b6d9c1e217b4f0aada9.svg";
export { ForwardRef as ReactComponent };